export * from './components/FloatingSuggestions/FloatingPeopleSuggestions/index';
